import React, { useId } from "react";

interface SwitchProps {
  name: string;
  onChange: (event: any) => void;
  onBlur: () => void;
  checked: boolean;
  disabled?: boolean;
  label?: string;
  className?: string;
}

export const Switch = ({
  name,
  checked,
  onChange,
  label,
  disabled,
  className,
}: SwitchProps) => {
  const id = useId();

  return (
    <div
      className={
        `flex justify-between items-center gap-4 cursor-pointer ` +
        (className ?? "")
      }
      data-testid={`pazia-switch-${name}`}
    >
      {label && (
        <div
          onClick={() => {
            if (disabled) return;
            onChange({ target: { name, value: !checked } });
          }}
        >
          {label}
        </div>
      )}
      <div className="form-switch">
        <input
          type="checkbox"
          aria-checked={checked}
          id={id + name}
          className="sr-only"
          name={id + name}
          checked={checked}
          defaultChecked={checked}
          onChange={(x) => {
            if (disabled) return;
            onChange(x);
          }}
        />

        <label
          className={`bg-slate-400 dark:bg-slate-700 ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
          htmlFor={id + name}
        >
          <span className="bg-white shadow-sm" aria-hidden="true"></span>
          {label && <span className="sr-only">{label}</span>}
        </label>
      </div>
    </div>
  );
};
